document.addEventListener("DOMContentLoaded", function () {
  const thumbsDesktop = new Swiper(".mainGalleryThumbs", {
    spaceBetween: 16,
    slidesPerView: "auto",
    watchSlidesProgress: true,
    direction: "vertical",
    slideToClickedSlide: true,
    navigation: {
      nextEl: ".mainGalleryThumbs-button-next",
      prevEl: ".mainGalleryThumbs-button-prev",
    },
  });

  const thumbsMobile = new Swiper(".mainGalleryThumbsMobile", {
    spaceBetween: 16,
    slidesPerView: 3,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
  });

  const main = new Swiper(".mainGallery", {
    slidesPerView: 1,
    navigation: {
      nextEl: ".mainGallery-button-next",
      prevEl: ".mainGallery-button-prev",
    },
    on: {
      init(sw) {
        const i = sw.activeIndex || 0;
        thumbsDesktop.slideTo(i, 0);
        thumbsMobile.slideTo(i, 0);
        updateThumbActive(i);
      },
    },
  });

  function enableThumbClick(swiper) {
    swiper.on("click", () => {
      const i = swiper.clickedIndex;
      if (typeof i === "number" && i >= 0) {
        main.slideTo(i);
        thumbsDesktop.slideTo(i);
        thumbsMobile.slideTo(i);
        updateThumbActive(i);
      }
    });
  }
  enableThumbClick(thumbsDesktop);
  enableThumbClick(thumbsMobile);

  main.on("slideChange", () => {
    const i = main.activeIndex;
    thumbsDesktop.slideTo(i);
    thumbsMobile.slideTo(i);
    updateThumbActive(i);
  });

  function updateThumbActive(activeIndex) {
    [thumbsDesktop, thumbsMobile].forEach((sw) => {
      sw.slides.forEach((sl) => sl.classList.remove("is-thumb-active"));
      const s = sw.slides[activeIndex];
      if (s) s.classList.add("is-thumb-active");

      sw.updateSlidesClasses();
    });
  }

  // Gallery: jump to variant featured media (Option B)
  let variantMediaMap = {};
  const variantMediaEl = document.getElementById("variant-media-json");
  if (variantMediaEl) {
    try {
      variantMediaMap = JSON.parse(variantMediaEl.textContent || variantMediaEl.innerHTML || "{}");
    } catch (err) {
      console.warn("variant-media-json invalid JSON", err);
      variantMediaMap = {};
    }
  }

  function slideToMediaId(mediaId) {
    if (!mediaId) return;

    const slides = Array.from(
      document.querySelectorAll(".mainGallery .swiper-wrapper > .swiper-slide")
    );

    const idx = slides.findIndex((s) => String(s.dataset.mediaId) === String(mediaId));
    if (idx < 0) return;

    main.slideTo(idx);
    thumbsDesktop.slideTo(idx);
    thumbsMobile.slideTo(idx);
    updateThumbActive(idx);
  }

  //Info section tabs
  const SINGLE_OPEN = true;

  const sections = document.querySelectorAll(".product-info");

  const setOpenState = (section, open) => {
    const btn = section.querySelector(".product-info-button");
    const content = section.querySelector(".product-info-content");
    const plus = section.querySelector(".product-info-button .plus");
    const minus = section.querySelector(".product-info-button .minus");

    if (!btn || !content || !plus || !minus) return;

    if (open) {
      content.classList.remove("hidden");
      plus.classList.add("hidden");
      minus.classList.remove("hidden");
      btn.setAttribute("aria-expanded", "true");
    } else {
      content.classList.add("hidden");
      plus.classList.remove("hidden");
      minus.classList.add("hidden");
      btn.setAttribute("aria-expanded", "false");
    }
  };

  sections.forEach((section) => {
    const btn = section.querySelector(".product-info-button");
    if (!btn) return;

    setOpenState(section, false);
    btn.setAttribute("aria-controls", "");
    btn.setAttribute("aria-expanded", "false");
    btn.setAttribute("type", "button");

    btn.addEventListener("click", () => {
      const content = section.querySelector(".product-info-content");
      const isOpen = !content.classList.contains("hidden");

      if (SINGLE_OPEN && !isOpen) {
        sections.forEach((s) => s !== section && setOpenState(s, false));
      }
      setOpenState(section, !isOpen);
    });
  });

  // Variant swatches
  const variantsJson = JSON.parse(document.getElementById("variants-json").innerHTML);
  const qtyAndBuyButton = document.querySelector(".js-qty-and-buy-button");

  const whereToBuyBtnsMap = new Map();
  let selectedWhereToBuyBtn = null;
  document.querySelectorAll(".js-where-to-buy-btn").forEach((btn) => {
    whereToBuyBtnsMap.set(btn.dataset.variantId, btn);

    if (btn.ariaHidden != "true") {
      selectedWhereToBuyBtn = btn;
    }
  });

  const swatches = document.querySelectorAll(".js-variant-swatch");
  const productQtyInputs = document.querySelectorAll(".product-qty");
  swatches.forEach((swatch) =>
    swatch.addEventListener("change", (e) => {
      const variantId = e.target.value;

      // Jump gallery to this variant's featured media
      slideToMediaId(variantMediaMap[String(variantId)]);

      const newWhereToBuyBtn = whereToBuyBtnsMap.get(variantId);

      if (selectedWhereToBuyBtn && newWhereToBuyBtn) {
        selectedWhereToBuyBtn.setAttribute("aria-hidden", true);
        newWhereToBuyBtn.setAttribute("aria-hidden", false);
        selectedWhereToBuyBtn = newWhereToBuyBtn;
        window.dispatchEvent(new Event("resize"));
      }

      const newVariantQuantity = variantsJson[variantId].quantity;
      productQtyInputs.forEach((input) => {
        input.value = 1;
        input.dataset.max = newVariantQuantity;
      });

      qtyAndBuyButton?.setAttribute("aria-hidden", newVariantQuantity === 0);
    })
  );

  // Initial sync on load (checked swatch)
  const initialChecked = document.querySelector(".js-variant-swatch:checked");
  if (initialChecked) {
    slideToMediaId(variantMediaMap[String(initialChecked.value)]);
  }

  //Product quantity input
  productQtyInputs.forEach((input) => {
    const wrapper = input.closest("div");
    if (!wrapper) return;

    const minusBtn = wrapper.querySelector("button:first-of-type");
    const plusBtn = wrapper.querySelector("button:last-of-type");

    let value = parseInt(input.value, 10) || 1;

    const updateValue = (newVal) => {
      const maxValue = parseInt(input.dataset.max) || 9999;
      if (newVal < 1) newVal = 1;
      if (newVal > maxValue) newVal = maxValue;
      value = newVal;
      input.value = value;
    };

    minusBtn.addEventListener("click", (e) => {
      e.preventDefault();
      updateValue(value - 1);
    });

    plusBtn.addEventListener("click", (e) => {
      e.preventDefault();
      updateValue(value + 1);
    });
  });
});


//GA4 Events Helper
(function() {
  // Wait for gtag to be available 
  let attempts = 0;
  
  function waitForGtag() {
    attempts++;

    if (typeof window.gtag === 'function') {

      setupTracking();
    } else if (attempts < 50) {
      setTimeout(waitForGtag, 100);
    } else {

    }
  }
  
  function setupTracking() {
    const retailerMap = {
      'walmart': 'pdp_click_walmart',
      'amazon': 'pdp_click_amazon',
      'target': 'pdp_click_target',
      'chewy': 'pdp_click_chewy',
      'petsmart': 'pdp_click_petsmart',
      'tractorsupply': 'pdp_click_tractorsupply',
      'tractor supply': 'pdp_click_tractorsupply',
      'petco': 'pdp_click_petco'
    };

    function getEventNameFromText(text) {
      const lowerText = text.toLowerCase();
      for (const [key, value] of Object.entries(retailerMap)) {
        if (lowerText.includes(key)) {
          return value;
        }
      }
      return 'pdp_click_other_retailer';
    }

    function getEventNameFromUrl(url) {
      const lowerUrl = url.toLowerCase();
      for (const [key, value] of Object.entries(retailerMap)) {
        if (lowerUrl.includes(key)) {
          return value;
        }
      }
      return 'pdp_click_other_retailer';
    }

    function getDomain(url) {
      try {
        return new URL(url).hostname.replace(/^www\./, '').toLowerCase();
      } catch (e) {
        return '';
      }
    }

    document.addEventListener('click', function(e) {
      // Check if click is inside PriceSpider widget
      const psContainer = e.target.closest('.ps-wtb');
      if (!psContainer) return;

      // Check for button clicks (PriceSpider uses buttons)
      const button = e.target.closest('button.ps-online-buy-button, button.ps-online-seller-button');
      
      if (button) {
       
        // Try to get retailer info from aria-label or button text
        const ariaLabel = button.getAttribute('aria-label') || '';
        const buttonText = button.textContent || '';
        const combinedText = ariaLabel + ' ' + buttonText;

        const eventName = getEventNameFromText(combinedText);

        window.gtag('event', eventName, {
          button_text: buttonText.trim(),
          aria_label: ariaLabel,
          page_location: window.location.href,
          page_path: window.location.pathname,
          transport_type: 'beacon'
        });
        return;
      }

      // Also check for link clicks (fallback)
      const link = e.target.closest('a');
      if (link && link.href) {

        const url = link.href;
        const eventName = getEventNameFromUrl(url);
        
        window.gtag('event', eventName, {
          link_url: url,
          retailer_domain: getDomain(url),
          page_location: window.location.href,
          page_path: window.location.pathname,
          transport_type: 'beacon'
        });
      }
    }, true);
  }
 
  // Start checking for gtag
  waitForGtag();
})();
